package org.zest.insan_360_website.components.widgets
import org.zest.insan_360_website.data.localized

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.Width
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.icons.fa.FaCopy
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.window
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.s
import org.zest.insan_360_website.components.layouts.userDashWordLibrary
import org.zest.insan_360_website.components.layouts.userPageBorderStrongColor
import org.zest.insan_360_website.components.layouts.userPagePrimaryTextColor
import org.zest.insan_360_website.components.layouts.userPageSecondaryTextColor
import org.zest.insan_360_website.data.page_states.UserPreferences

@Composable
fun CopyableIdText(
    id: String?,
    fallbackText: String = "N/A"
) {
    val toast = LocalToast.current
    var isHovered by remember { mutableStateOf(false) }

    val fullId = id ?: ""
    val displayId =
        if (fullId.length > 12) "${fullId.take(8)}...${fullId.takeLast(4)}" else fullId

    Row(
        Modifier
            .width(Width.FitContent)
            .padding(leftRight = 0.5.cssRem, topBottom = 0.25.cssRem)
            .margin(
                top = (-0.25).cssRem,
                left = (-0.5).cssRem,
                bottom = (-0.25).cssRem
            )
            .backgroundColor(
                if (isHovered && fullId.isNotEmpty()) userPageBorderStrongColor.copyf(alpha = 0.5f) else
                    Colors.Transparent
            )
            .borderRadius(2.cssRem)
            .cursor(
                if (fullId.isNotEmpty()) Cursor.Pointer else
                    Cursor.Default
            )
            .transition {
                property("background-color")
                duration(0.2.s)
            }
            .onMouseEnter { isHovered = true }
            .onMouseLeave { isHovered = false }
            .onClick { e ->
                e.stopPropagation()
                if (fullId.isNotEmpty()) {
                    window.navigator.clipboard.writeText(fullId)
                    toast.show(userDashWordLibrary.id_copied.localized)
                }
            }
            .fontSize(0.875.cssRem),
        verticalAlignment = Alignment.CenterVertically
    ) {
        SpanText(
            if (fullId.isNotEmpty()) displayId else fallbackText,
            Modifier
                .color(
                    if (isHovered && fullId.isNotEmpty())
                        userPagePrimaryTextColor else userPageSecondaryTextColor
                )
                .transition { property("color"); duration(0.2.s) }
                .whiteSpace(WhiteSpace.NoWrap)
        )

        if (fullId.isNotEmpty()) {
            FaCopy(
                Modifier
                    .margin(left = 0.4.cssRem)
                    .opacity(if (isHovered) 1f else 0f)
                    .transition {
                        property("opacity")
                        duration(0.2.s)
                    }
            )
        }
    }
}